import { useQuery } from "@tanstack/react-query";
import { axios } from "@via/api/axios.tsx";
import { type GetUserCredentialsResponse } from "common";

export const fetchSavedCredentialsList =
  async (): Promise<GetUserCredentialsResponse> => {
    try {
      const params = { type: "userOwned" };
      const res = await axios.get("/api/user/v1/credentials", { params });
      return res.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

export const useGetSavedAmazonCredentialsList = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ["/api/user/v1/credentials"],
    queryFn: fetchSavedCredentialsList,
    retry: true,
    enabled,
    select: data => data?.amazonCredentials ?? [],
  });
};

export const useGetSavedGoogleCredentialsList = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ["/api/user/v1/credentials"],
    queryFn: fetchSavedCredentialsList,
    retry: true,
    enabled,
    select: data => data?.googleCredentials ?? [],
  });
};
